import store from '@/store/index';
import { ERROR_DETAILS } from '@/constants/error-details';
import { errorMessages } from './constants';

function handleNetworkError(error) {
	if (error.code === undefined && error.message === 'Network Error') {
		store.dispatch('showErrorModal', {
			error: 'Network Error',
			errorDetails: {
				...ERROR_DETAILS.NETWORK_ERROR,
				message: errorMessages.NETWORK_ERROR,
			},
		});
	}
}

function handleF5Block(error) {
	// Handle F5 blocks when there is a status code of 42
	if (error.response && error.response.request.status === 42) {
		callErrorModalAction();
		// Handle F5 blocks without a status code of 42
	} else if (
		error.response &&
		typeof error.response.data === 'string' &&
		error.response.data.includes('Your F5 support ID is:')
	) {
		callErrorModalAction();
	}

	function callErrorModalAction() {
		const regex = /<\/strong>(?<supportId>\d+)/;
		const { groups: { supportId = null } = {} } =
			error.response.data.match(regex);
		store.dispatch('showErrorModal', {
			error: 'This is an F5 error',
			errorDetails: {
				...ERROR_DETAILS.F5_BLOCK,
				message: `${errorMessages.F5_BLOCK} ${supportId}`,
			},
		});
	}
}

export { handleNetworkError, handleF5Block };
